export const RadioCustomStyles = {
  color: '#ffa501',
};
